"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCustomerData = void 0;
/* eslint-disable @typescript-eslint/naming-convention -- Genesys preset naming */

const getCustomerData = ({
  data,
  language,
  tenant
}) => {
  const {
    customerId: customerCustomerId,
    consultantNumber,
    customerType,
    emails,
    firstName,
    lastName,
    phones
  } = data?.customer ?? {};
  const response = {
    'context.customField1Label': 'Customer Title',
    'context.customField1': customerType?.description ?? 'Anonymous',
    'context.customField2Label': 'Consultant Number',
    'context.customField2': consultantNumber ?? '',
    'context.customField3Label': 'Language Code',
    'context.customField3': language.slice(0, 2).toUpperCase(),
    'context.customField4Label': 'Market Code',
    'context.customField4': tenant.toUpperCase(),
    'context.customerId': customerCustomerId ?? '',
    'context.email': emails?.[0]?.emailAddress ?? '',
    'context.firstName': firstName ?? '',
    'context.lastName': lastName ?? '',
    'context.phoneNumber': phones?.[0]?.telephoneNumber ?? '',
    'context.source': 'web'
  };

  // eslint-disable-next-line no-console -- debug info required to investigate issues
  console.log(response);
  return response;
};
exports.getCustomerData = getCustomerData;
